import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faPen } from '@fortawesome/free-solid-svg-icons';

import { Grid, Typography, Tooltip, IconButton } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import Paper from '@material-ui/core/Paper';
import MTable from '../../../components/MTable';
import Filter from '../../../components/Filter/components';
import FilterMobile from '../../../components/FilterMobile/components';
import Button from '../../../components/Button';
import TableMobile from '../../../components/TableMobile';

import AccountRegistration from './AccountRegistration';

import { loadFilters } from '../../../components/Filter/store/thunk';
import { formatFilters } from '../../../helpers/formatters';
import useDidMount from '../../../helpers/hooks/useDidMount';
import { loadAccount, loadAccounts } from '../store/thunk';
import { openRegistrationModal, clearRegistration } from '../store/actions';

const PencilIcon = require('../../../assets/img/icon_pencil.svg');

const headers = [
  { title: 'Descrição', field: 'accountName', sortable: false },
  { title: 'Banco', field: 'bankName', sortable: false }
];

const width = window.innerWidth;
const isMobile = width < 1024;
const tableRowWidth = width < 768 ? 120 : 200;

export default function Accounts() {
  const dispatch = useDispatch();

  const didComponentMount = useDidMount();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { list, registration, total, isLoading } = useSelector(state => state.accounts);
  const { selects, qp } = useSelector(state => state.filters);

  const filters = formatFilters(['status'], selects);

  const [accountsPage, setAccountsPage] = useState(1);
  const accountsPageSize = 10;
  const accountsPageCount = Math.ceil(total / accountsPageSize);

  const handleLoadAccounts = ({ page, qp }) => {
    if(userId) {
      return dispatch(loadAccounts({ page, qp, userId, establishmentId }));
    }
  }

  const handleRegistration = () => {
    dispatch(clearRegistration());
    dispatch(openRegistrationModal(true));
  }

  const handleUpdate = account => {
    const params = {
      userId,
      establishmentId: establishmentId,
      accountId: account.accountId
    }

    dispatch(loadAccount(params));
  }

  useEffect(() => {
    handleLoadAccounts({ page: 1, qp: '' });
    dispatch(loadFilters(userId, establishmentId));
  }, [userId, establishmentId]);

  useEffect(() => {
    if(!didComponentMount) {
      handleLoadAccounts({ page: accountsPage, qp });
    }
  }, [accountsPage]);

  return(
    <>
      {registration && (
        <AccountRegistration isOpen={registration} />
      )}
      {isMobile && (
        <Button
          type="button"
          color="success"
          startIcon={
            <FontAwesomeIcon
              icon={faPlusCircle}
              color="#FFFFFF"
              size="xs"
            />
          }
          onClick={handleRegistration}
          style={{ marginBottom: 10 }}
        >
          Cadastrar Conta
        </Button>
      )}
      <Paper>
        {isMobile ? (
          <FilterMobile
            filter
            hasSearchTerm
            filters={filters}
            handlePageRequest={handleLoadAccounts}
          />
        ) : (
          <Filter
            filter
            hasSearchTerm
            filters={filters}
            handlePageRequest={handleLoadAccounts}
            actionButton={
              <Button
                type="button"
                color="primary"
                startIcon={
                  <FontAwesomeIcon
                    icon={faPlusCircle}
                    color="#FFFFFF"
                    size="xs"
                  />
                }
                onClick={handleRegistration}
              >
                Adicionar Conta
              </Button>
            }
          />
        )}
        {isMobile ? (
          <TableMobile
            loading={isLoading}
            data={list?.map(item => {
              return {
                ...item,
                accountName: {
                  index: 1,
                  label: 'Descrição',
                  value: <Typography color='textSecondary' variant='body2' style={{ wordBreak: 'break-all' }}>{item?.accountName}</Typography>
                },
                bankName: {
                  index: 1,
                  label: 'Banco',
                  value: <Typography color='textSecondary' variant='body2' style={{ wordBreak: 'break-all' }}>{item?.bankName}</Typography>
                }
              }
            })}
            actions={[
              {
                action: rowData => {
                  if(rowData?.mainAccount == 1 && rowData?.accountTypeId == 1) {
                    return null;
                  }

                  return(
                    <Tooltip placement='top' title='Editar' enterTouchDelay={0}>
                      <IconButton
                        disabled={+rowData.mainAccount == 1 && +rowData.accountTypeId == 1}
                        onClick={() => handleUpdate(rowData)}
                      >
                        <img src={PencilIcon} />
                      </IconButton>
                    </Tooltip>
                  );
                }
              }
            ]}
          />
        ) : (
          <MTable
            loading={isLoading}
            headers={headers}
            data={list}
            actions={[
              rowData => ({
                icon: () => (rowData?.mainAccount == 1 && rowData?.accountTypeId == 1)
                  ? null
                  : (
                    <FontAwesomeIcon
                      icon={faPen}
                      color="#022A5C"
                      size="xs"
                    />
                  ),
                tooltip: (rowData.mainAccount == 1 && rowData.accountTypeId == 1) ? null : 'Editar',
                onClick: (_, rowData) => handleUpdate(rowData),
                disabled: (rowData.mainAccount == 1 && rowData.accountTypeId == 1)
              })
            ]}
            actionColumnWidth={tableRowWidth}
          />
        )}
        <Grid
          container
          xs={12}
          style={{ padding: 10, display: 'flex', justifyContent: 'flex-end' }}
        >
          <Pagination
            color="primary"
            variant="outlined"
            shape="rounded"
            count={accountsPageCount}
            page={accountsPage}
            onChange={(_, page) => setAccountsPage(page)}
          />
        </Grid>
      </Paper>
    </>
  );
}